import { render, staticRenderFns } from "./AdminCardTitle.vue?vue&type=template&id=61812982&lang=pug"
import script from "./AdminCardTitle.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminCardTitle.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.18_cache-loader@4.1.0_webpack@4.47.0_supports-_a02809e54f1429825a019cd6b08a4fe2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports